import { useTranslation } from 'react-i18next';

import { cn } from '@nucleus-commerce/ui/lib/utils';

import { adminAppUrl } from '@/shared/admin-app';

/** The legal pages are static files the admin app serves; without its URL there is nothing to link. */
export function LegalLinks({ className }: { className?: string }) {
  const { t } = useTranslation('common');
  const base = adminAppUrl()?.replace(/\/+$/, '');
  if (!base) return null;
  return (
    <nav aria-label={t('legal.nav')} className={cn('flex flex-wrap gap-5', className)}>
      <a href={`${base}/legal/terms.html`} target="_blank" rel="noreferrer">
        {t('legal.terms')}
      </a>
      <a href={`${base}/legal/privacy.html`} target="_blank" rel="noreferrer">
        {t('legal.privacy')}
      </a>
      <a href={`${base}/legal/dpa.html`} target="_blank" rel="noreferrer">
        {t('legal.dpa')}
      </a>
    </nav>
  );
}
